import script from "./ProductView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductView.vue?vue&type=script&setup=true&lang=ts"

import "./ProductView.vue?vue&type=style&index=0&id=640032f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-640032f8"]])

export default __exports__